import { OktaAuth } from '@okta/okta-auth-js';
let config = require('../config/' + process.env.NODE_ENV);

export const APPLICATION_PATH = '/manager';
const isReplicaEnv =
  process.env.NODE_ENV === 'production' && location.host.replace('www.', '').startsWith('econsent-replica');
const isPlanetEnv = process.env.NODE_ENV === 'production' && location.host.includes('app.dev.ecoa.signanthealth.dev');

let issuer = config.oktaIssuer;
let clientId = config.oktaClientId;
if (isReplicaEnv) {
  issuer = config.oktaIssuerQA;
  clientId = config.oktaClientIdQA;
}
if (isPlanetEnv) {
  issuer = config.oktaIssuerDEV;
  clientId = config.oktaClientIdDEV;
}

const oktaConfig = {
  issuer: issuer,
  clientId: clientId,
  redirectUri: config.oktaRedirectPath,
  postLogoutRedirectUri: config.oktaPostLogoutUrl,
  tokenManager: {
    storageKey: `okta-token-storage-${config.oktaStorageId}`
  },
  scopes: ['openid', 'offline_access']
};

export const oktaClient = new OktaAuth(oktaConfig);
